import { useState, useEffect } from "react";
import axios from "axios";
import { multiFormatDateString } from "../../utils/DateConvertor";
import "../../assets/css/post/comments.css";
import usePopupMsg from "../../hooks/usePopupMsg";
import useDeleteModal from "../../hooks/useDeleteModal";
import { useTranslation } from "react-i18next";

const CommentCard = ({ comment, postId, onDelete, onUpdate }) => {

  const [isEditing, setIsEditing] = useState(false);
  const [editedBody, setEditedBody] = useState(comment.body);
  const [loading, setLoading] = useState(false);
  const [isCreator, setIsCreator] = useState(false)
  const uDeleteModal = useDeleteModal()
  const {t} = useTranslation('common')
  const translation = t("comment")


  useEffect(() => {
    if (comment) {
      setIsCreator(comment.is_creator_access);
    }
  }, [comment]);

  if (!comment) return null;

  const handleUpdate = async () => {
      
    if (!editedBody.trim()) return usePopupMsg.getState().open(`${translation.empty_comment}`, "error");;

    try {
      setLoading(true);
      await axios.put(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/post/update-comment/`,
        {
          id: comment.id,
          post_id: postId,
          body: editedBody,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      onUpdate(comment.id, editedBody); // callback to parent to update in state
      setIsEditing(false);
      usePopupMsg.getState().open(`${translation.updated_success_msg}`, "success");
    } catch (error) {
      if (error.response?.data?.body){
        var msg =  error.response?.data?.body[0]
      } else if (error.response?.data?.message) {
        msg =  error.response?.data?.message
      } else {
        msg =  "oops, something went wrong! we are fixing it"
      }
      usePopupMsg.getState().open(`${msg}`, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-3 border border-gray-600 dark:border-white dark:bg-gray-500 bg-blue-50 rounded-md p-3 w-auto shadow-sm">
      <div className="flex justify-between items-center">
        <span className="text-lg font-bold dark:text-black border-b-2 border-gray-800">
          {comment.user}
        </span>
        <span className="text-sm text-gray-700 dark:text-gray-200">
          {multiFormatDateString(comment.created)}
        </span>
      </div>

      {isCreator && isEditing ? (
        <textarea
          value={editedBody}
          onChange={(e) => setEditedBody(e.target.value)}
          className="w-full p-2 mt-2 rounded-md border border-gray-400 dark:text-black"
          rows={3}
        />
      ) : (
        <pre className="my-3 text-dark-1 rounded-lg dark:text-black font-sans whitespace-pre-wrap break-words">
          {comment.body}
        </pre>
      )}
      
      {isCreator && (
          <div className="flex gap-3 mt-2">
          {isEditing ? (
            <>
              <button
                onClick={handleUpdate}
                disabled={loading}
                className="update-btn"
              >
                {translation.save}
              </button>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setEditedBody(comment.body);
                }}
                className="cancel-btn"
              >
                {translation.cancel}
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => setIsEditing(true)}
                className="update-btn"
              >
                {translation.edit}
              </button>
              <button
                onClick={()=>
                  {
                    uDeleteModal.open({
                      endpoint: `/post/delete-comment/${comment.id}/`,
                      payload: {},
                      messages: {
                        heading: `${translation.delete_comment_heading}`,
                        message: `${translation.msg} "${comment.body.slice(0,10)}"?`,
                        warning: `${translation.warning_msg}`,
                        success: `${translation.success_msg}`,
                        error: `${translation.error_msg}`,
                        cancel: `${translation.cancel}`,
                        confirm: `${translation.delete}`,
                      },
                      onSuccess: () =>{onDelete(comment.id)}
                    });
                  }}
                className="delete-btn"
              >
                {translation.delete}
              </button>
            </>
          )}
        </div>
      )}
      

    </div>
  );
};

export default CommentCard;
